<template>
    <div>
        <form @submit.prevent="data.fetch()" class="row my-4 align-items-center pr-3">

            <div class="col-lg-2">
                <select @change="data.fetch()" v-model="data.filters.size" class="custom-select" required="">
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="25">25</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
            </div>
            <div class=" col-lg-3 col-6 input-group py-1">
                <input
                    type="date"
                    class="form-control"
                    v-model="tempStartDate"
                    placeholder="Start Date"
                />
            </div>
            <div class="col-lg-3 col-6 input-group py-1">
                <input
                    type="date"
                    class="form-control"
                    v-model="tempEndDate"
                    placeholder="End Date"
                />
            </div>
            <div class="input-group col-lg-3 ml-auto">
                <div class="input-group-prepend"> <span class="input-group-text bg-white"><i class="fas fa-search"></i></span> </div>
                <input type="text" class="form-control"  v-model="data.filters.search" placeholder="Search....">
            </div>
            <button @click.prevent="data.fetch()" :class="['btn btn-primary btn-sm text-white px-3 shadow-none' , data.loading ? 'btn-loading' : '']"><i class="fas fa-arrow-alt-circle-right"></i></button>
        </form>
            <!-- All Transactions ============================================= -->
            <div class="bg-light shadow-sm rounded py-4 mb-4">
                <div class="d-flex justify-content-center align-items-center mb-4 px-4">
                    <div class="d-flex align-items-center mb-0">
                        <h3 class="text-4 font-weight-700 d-flex align-items-center mb-0">
                            Wallet Statement
                        </h3>
                    </div>
                    <button
                        class="btn btn-outline-primary btn-sm shadow-none ml-auto"
                        @click="downloadStatement"
                    >
                        <i class="fas fa-download mr-2"></i>Statement
                    </button>
                </div>
                <transition name="shake">
                    <div v-if="message" class="m-auto mb-4">
                        <small  class="alert alert-danger center-text">{{ message }}</small>
                    </div>
                </transition>
                <!-- Title =============================== -->
                <div class="transaction-title py-2 px-4">
                    <div class="row">
                        <div class="col-2 col-sm-1 text-center"><span class="">Date</span></div>
                        <div class="col col-sm-3 d-none d-sm-block ">Reference</div>
                        <div class="col col-sm-3">Description</div>
                        <div class="col col-sm-1 d-none d-sm-block ">Type</div>
                        <div class="col-auto col-sm-2 text-center">Amount</div>
                        <div class="col-3 col-sm-2 d-none d-sm-block  text-right">Balance</div>
                    </div>
                </div>
                <!-- Title End -->

                <!-- Transaction List
                =============================== -->
                <div class="transaction-list">
                    <div v-for="row in data.content.data" :key="row.id" class="transaction-item d-block px-4 py-3">
                        <div class="row align-items-center flex-row">
                            <div class="col-2 col-sm-1 text-center row-text">
                                <FormattedDate :dateString="row.created_at" />
                            </div>
                            <div class="col col-sm-3 d-none d-sm-block ">
                                <span class="">TN # {{ row.id}}</span>
                                <span class="d-block row-text">Tran Ref #{{ row.transaction_ref }}</span>
                            </div>
                            <div class="col col-sm-3">
                                <span class="">{{ row.description }}</span>
                            </div>
                            <div class="col col-sm-1 d-none d-sm-block ">
                                <span class="row-text">{{ row.type }}</span>
                            </div>
                            <div class="col-3 col-sm-2 text-right row-text">
                                <span :class="{'text-muted': row.type === 'DEBIT'}">
                                    {{ row.type === 'DEBIT' ? '-' : '' }}{{ wallet.content.currency === 'USD' ? 'USD' : 'ZWG' }} {{ money(row.amount) }}
                                </span>
                            </div>
                            <div class="col-3 col-sm-2 text-right d-none d-sm-block ">
                                <span class="text-black row-text">
                                    {{ wallet.content.currency === 'USD' ? 'USD' : 'ZWG'  }} {{ money(row.balance)}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Transaction List End -->

                <!-- Pagination ============================================= -->
                <div class="d-flex align-items-center justify-content-between px-4">
                <span class="text-black-50">
                    Showing {{ data.content.data.length }} of {{ data.content.total }} Records
                </span>
                    <ul class="pagination justify-content-center mt-4 mb-0">
                        <li class="page-item disabled">
                            <a class="page-link" href="#" tabindex="-1">
                                <i class="fas fa-angle-left"></i>
                            </a>
                        </li>
                        <li class="page-item active">
                            <a @click="data.append()"
                               v-if="data.content.total !== data.content.to && data.content.data.length > 0"
                               class="page-link" href="#">
                                Load More <span class="sr-only">(current)</span>
                            </a>
                        </li>
                        <li class="page-item d-flex align-content-center flex-wrap text-muted text-5 mx-1">
                            <span>...</span>
                        </li>
                        <li class="page-item disabled">
                            <a class="page-link" href="#" tabindex="-1">
                                <i class="fas fa-angle-right"></i>
                            </a>
                        </li>
                    </ul>
                </div>
                <!-- Paginations end -->
            </div>
        </div>
    </div>
</template>

<script>
import FormattedDate from "../../../core/FormattedDate.vue";
import {money} from "../../../../core/forms/money";
import Form from "../../../../core/forms/form";

export default {
    name: "Wallet",
    components: {FormattedDate},
    props: ['data','wallet'],
    mixins: [money],
    data(){
        return {
            message:'',
            tempStartDate: '',
            tempEndDate: '',
            form: new Form({
                startDate: '',
                endDate: ''
            }),
        };
    },
    methods : {
        downloadStatement() {
            this.message = '';
            if (!this.tempStartDate || !this.tempEndDate) {
                this.message = "Please set both the start date and end date before downloading the statement.";
                return;
            }
            const payload = {
                startDate: this.tempStartDate,
                endDate: this.tempEndDate,
            };
            axios.post(`/business/wallets/${this.$route.params.id}/api/generate-statement`, payload, {
                responseType: 'blob',
            })
                .then((response) => {
                    const blob = new Blob([response.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    });
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `statement_${new Date().toISOString().slice(0, 19)}.xlsx`;
                    link.click();
                })
                .catch((error) => {
                    console.error("Error downloading statement:", error);
                });
        },
    },
}
</script>

<style scoped>
.center-text {
    display: block;
    text-align: center;
}
.row-text{
    color: #252c65;
}


</style>
